import { ModelType } from "@/gql/graphql";
import { ActivityLogFeed } from "@/app/ActivityLogs/Components/ActivityLogFeed";
import { useIncidentRecord } from "@/app/Incidents/Hooks/useIncidentRecord";

export function IncidentActivityScreen() {
  const incident = useIncidentRecord();

  return (
    <div className="py-10">
      <ActivityLogFeed modelId={incident.id} modelType={ModelType.Incident} />
    </div>
  );
}
